import { afterNextRender, Component, inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environment';

/** URL absolue du PDF de la politique de confidentialité (document statique). */
export const PRIVACY_POLICY_PDF_URL = `${environment.appUrl}/assets/documents/Politique_de_confidentialité.pdf`;

@Component({
  selector: 'app-privacy-policy-page',
  template: ``,
  styles: [],
  standalone: false,
})
export class PrivacyPolicyPageComponent {
  platformId = inject(PLATFORM_ID);

  constructor() {
    afterNextRender(() => {
      window.location.href = PRIVACY_POLICY_PDF_URL;
    });
  }
}
